import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import rootReducer from './rootReducer';
import promiseMiddleware from './middleware/redux-promise-middleware';
import shouldFetchMiddleware from './middleware/should-fetch-middleware';
import loadingAnimationMiddleware from './middleware/loading-animation-middleware';

export default function configureStore({ initialState = {}, history }) {
	// Compose final middleware and use devtools in debug environment
	const middleware = applyMiddleware(
		thunk,
		routerMiddleware(history),
		shouldFetchMiddleware,
		promiseMiddleware({
			promiseTypeSuffixes: ['PENDING', 'SUCCESS', 'FAILURE'],
		}),
		loadingAnimationMiddleware
	);

	return middleware(createStore)(
		rootReducer,
		initialState,
		window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() // eslint-disable-line no-underscore-dangle
	);
}



// WEBPACK FOOTER //
// ./src/redux/configureStore.js